import { Field } from "formik";
import { t } from "i18next";
import React from "react";
import { STRING_CONSTANT } from "../../../constants/constants";

const FormRegistrationTypeField = (props) => {
  const { handleRegTypeChange, setFieldValue, feesList, error, touched } =
    props;
  return (
    <div className="mb-3">
      <label htmlFor="registrationType" className="form-label">
        {t("type-of-registration")}
        <span className="text-danger">{STRING_CONSTANT.SPACE}*</span>
      </label>
      <Field
        as="select"
        className="form-select"
        id="registrationType"
        name="registrationType"
        onChange={(event) => handleRegTypeChange(event, setFieldValue)}
      >
        <option value={STRING_CONSTANT.BLANK}>{t("select")}</option>
        {feesList?.map((fee, index) => {
          return (
            fee.isMandatory && (
              <option
                key={fee?.subscriptionKey + index}
                value={fee?.subscriptionKey}
              >
                {fee?.subscriptionKey}
              </option>
            )
          );
        })}
      </Field>
      {error && touched ? (
        <div className="text-danger">{error}</div>
      ) : (
        STRING_CONSTANT.BLANK
      )}
    </div>
  );
};

export default FormRegistrationTypeField;
